import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleLinkClick = () => setMenuOpen(false);

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__container">
        <a href="/#top" className="navbar__brand">
          <img src="/ralli-logo.svg" alt="RalliPB" className="navbar__logo" />
          <span>RalliPB</span>
        </a>

        <div className="navbar__links">
          <a href="/#features">Features</a>
          <a href="/#how-it-works">How It Works</a>
          <a href="/#community">In the App</a>
          <a href="/#rankings">Skill Profile</a>
          <a href="/support">Support</a>
        </div>

        <div className="navbar__actions">
          <a href="/beta" className="btn btn--primary btn--sm">Beta Waitlist</a>
          <button
            className="navbar__hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="navbar__mobile">
          <a href="/#features" onClick={handleLinkClick}>Features</a>
          <a href="/#how-it-works" onClick={handleLinkClick}>How It Works</a>
          <a href="/#community" onClick={handleLinkClick}>In the App</a>
          <a href="/#rankings" onClick={handleLinkClick}>Skill Profile</a>
          <a href="/support" onClick={handleLinkClick}>Support</a>
          <a href="/beta" className="btn btn--primary" onClick={handleLinkClick}>Beta Waitlist</a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
